import { PrismicRichText } from '@prismicio/react';
import { PrimaryCTA } from 'remote-com-shared/components/CallToAction';
import { HalfLogo, Title, Description } from 'remote-com-shared/components/CallToAction/Primary';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import BgIllustration from './assets/cta-bg.svg';

import { fieldHasContent, transformProperties } from '@/src/domains/prismic/helpers';
import { desktopBreakpoint } from '@/src/domains/shared/breakpoints';

export const Section = styled(PrimaryCTA)`
  ${fluidProp(['padding-top', 'padding-bottom'], '90px', '120px')}
  background-color: #9c85ff;
  font-family: var(--typography-fontBossa);
  position: relative;
  overflow: hidden;

  ${HalfLogo} {
    display: none;
  }

  ${Title} {
    max-width: 783px;
    z-index: 1;
    position: relative;
  }

  ${Description} {
    z-index: 1;
    position: relative;
    color: var(--colors-blank);
    line-height: 155%;

    a {
      color: var(--colors-blank);
      text-decoration: underline;

      &:hover {
        text-decoration-thickness: 2px;
      }
    }
  }
`;

const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;

  ${desktopBreakpoint(css`
    display: none;
  `)}
`;

export function CTASlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { label, headingTitle, sectionDescription } = primary;

  return (
    <Section label={label} title={headingTitle} wideContent>
      {fieldHasContent(sectionDescription) && (
        <Description as="div">
          <PrismicRichText field={sectionDescription} />
        </Description>
      )}
      <ImageWrapper>
        <BgIllustration />
      </ImageWrapper>
    </Section>
  );
}
